import { moneyFormat } from '@/filters/toCurrency.filter'
import type { ChartOptions } from 'chart.js'
import type { ChartData } from 'chart.js'

export const barChartBase: ChartData = {
  labels: [],
  datasets: [
    {
      data: []
    }
  ]
}
export const options: ChartOptions = {
  responsive: true,
  backgroundColor: '#f48a2c',

  interaction: {
    mode: 'index',
    intersect: false
  },
  scales: {
    x: {
      grid: {
        color: '#f5f5f5'
      },
      ticks: {
        // For a category axis, the val is the index so the lookup via getLabelForValue is needed
        callback: function(val, index) {
          /* @ts-ignore */
          return this.getLabelForValue(val).replace('MorgenFund GmbH Frankfurt', 'MorgenFund FFM').replace('MorgenFund GmbH Zweigniederlassung Luxemburg', 'MorgenFund Lux');
        },
      }
    },

    y: {
      grid: {
        color: '#f5f5f5'
      }
    }
  },
  plugins: {
    tooltip: {
      backgroundColor: '#fff',
      titleColor: '#000',
      bodyColor: '#000',
      borderColor: '#f48a2c',
      borderWidth: 2,
      padding: 10,

      callbacks: {
        label: (tooltipItem) => {
          let label = tooltipItem.dataset.label || ''

          if (label) {
            label += ': '
          }
          if (tooltipItem.parsed.y !== null) {
            label += moneyFormat(tooltipItem.parsed.y, 2)
          }
          return label
        }
      }
    },
    title: {
      display: true,
      text: 'Bestandsprovision aller Banken'
    },
    legend: {
      display: false
    }
  }
}
